export default __webpack_public_path__ + "static/media/CTP_Dark_PT.d53fdb5f.svg";